export const loadChartJs = require('bundle-loader?lazy&name=chartjs!chart.js/dist/Chart');
export const loadFlickity = require('bundle-loader?lazy&name=flickity!flickity');
